import { CustomerDetails } from 'app/modules/customer-management/customer-details/components/CustomerDetails';

export const CustomerDetailsPage = (): JSX.Element => <CustomerDetails />;
